import React from "react";
import { Dropdown, Menu } from "antd";
import NavItem from "./NavItem";
import { NavItemConfig } from "../Siderbar.constant";

type Props = {
    parentClass?: string,
    children: React.ReactNode,
    TitleComp: React.ReactNode,
    items: NavItemConfig[],
    isActiveKey: string,
    closeOpenMenu?: () => void;
    handleItemClick: (item: NavItemConfig) => void
}

const CustomDropdown = ({ children, TitleComp, parentClass, isActiveKey, items, handleItemClick, closeOpenMenu } : Props) => {
    return (
        <Dropdown trigger={["click"]} placement="bottomLeft" align={{ offset: [40, -5] }} onVisibleChange={() => closeOpenMenu?.()}
            overlay={(
                <div className={`custom-dropdown ${parentClass || ""}`}>
                    {TitleComp}
                    {TitleComp && <div className="divider"></div>}
                    <Menu>
                        {items.map((item) => <NavItem {...{ item, isActive: isActiveKey === item.path, isOpen: false, hasChildren: false, onClick: () => handleItemClick(item) }} key={item.key} />)}
                    </Menu>
                </div>
            )}>
            {children}
        </Dropdown>
    );
};

export default CustomDropdown;